$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p === "organizer_event_ticket_category" && a == "list") {
    $(document).on("click", ".event-ticket-category-delete", function () {
      $(".alert").remove();

      let selected_event_ticket_category = $(this).attr("data-delete-id");

      $.ajax({
        type: "POST",
        url: "/ajax/organizer_event_ticket_category/delete",
        data: {
          event_ticket_category_id: selected_event_ticket_category,
        },
      })
        .done(function (data) {
          if (data.message !== undefined && data.message !== null) {
            let confirmAlert = confirm(data.message);
            if (confirmAlert === true) {
              unPublishEventTicketCategory(selected_event_ticket_category);
            }
          } else if (data === true) {
            $(
              "tr#event-ticket-category-id-" + selected_event_ticket_category,
            ).fadeOut(1000);
            setTimeout(function () {
              $(
                "tr#event-ticket-category-id-" + selected_event_ticket_category,
              ).remove();
            }, 1000);
            popupAlert();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            $(
              "#event-ticket-category-id-" + selected_event_ticket_category,
            ).after(
              '<tr><td colspan="8"><div class="alert alert-danger alert-dismissible" id="message"><a href="#" class="close product-delete-alert" aria-label="close">×</a>' +
                data.responseJSON.error_message +
                "</div></td></tr>",
            );
          }
        });

      return false;
    });

    $(document).on("click", ".product-delete-alert", function (e) {
      e.preventDefault();
      $(this)
        .closest("tr")
        .fadeOut(200, function () {
          $(this).remove();
        });
    });

    function unPublishEventTicketCategory(selected_event_ticket_category) {
      $.ajax({
        type: "POST",
        url: "/ajax/organizer_event_ticket_category/unpublish",
        data: {
          event_ticket_category_id: selected_event_ticket_category,
        },
      }).done(function (data) {
        if (data === true) {
          $(
            "tr#event-ticket-category-id-" + selected_event_ticket_category,
          ).fadeOut(1000);
          setTimeout(function () {
            $(
              "tr#event-ticket-category-id-" + selected_event_ticket_category,
            ).remove();
          }, 1000);
          popupAlert();
        }
      });
    }
  }
});
